import { render, staticRenderFns } from "./LoginPassword.vue?vue&type=template&id=3051b280&scoped=true&"
import script from "./LoginPassword.vue?vue&type=script&lang=ts&"
export * from "./LoginPassword.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPassword.vue?vue&type=style&index=0&id=3051b280&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051b280",
  null
  
)

export default component.exports